import React from "react";
import ReactTable from "react-table";
import { Badge } from "reactstrap";
import Pagination from "../../../components/DatatablePagination";
import { GetSelectTime } from "../../../helpers/SelectTime";
import { AddCommaNumber, AddCommaPhoneNumber } from "../../../helpers/Utils";
import moment from "moment";

import { injectIntl } from "react-intl";

const ContentMultiForm = (props) => {
  const { data, intl } = props;
  // console.log(data);
  const columns = [
    {
      Header: intl.formatMessage({ id: "warehouse.import.header.item" }),
      accessor: "stock",
      Cell: (props) => <span className="text-capitalize">{props.value}</span>,
    },
    {
      Header: intl.formatMessage({ id: "warehouse.import.header.unit" }),
      accessor: "unit",
      Cell: (props) => <span className="text-capitalize">{props.value}</span>,
    },
    // {
    //     Header: 'Mã số',
    //     accessor: 'code',
    //     Cell: (props) => (
    //         <span className='text-uppercase'>{props.value}</span>
    //     ),
    // },
    {
      Header: intl.formatMessage({ id: "warehouse.import.header.quantity" }),
      accessor: "quantity",
      Cell: (props) => AddCommaNumber(props.value),
    },
    {
      Header: intl.formatMessage({ id: "warehouse.import.header.price" }),
      accessor: "price",
      Cell: (props) => AddCommaNumber(props.value),
    },
    {
      Header: intl.formatMessage({ id: "warehouse.import.header.status" }),
      accessor: "status",
      Cell: (props) => (
        <Badge
          pill
          color={
            props.value === "Đã xét duyệt"
              ? "primary"
              : props.value === "Đang xét duyệt"
                ? "secondary"
                : "danger"
          }
        >
          {props.value}
        </Badge>
      ),
    },
    // {
    //     Header: 'Thống kê',
    //     accessor: 'time',
    //     Cell: (props) => GetSelectTime(props.value).label,
    // },
    // {
    //     Header: 'Người nhập liệu',
    //     accessor: 'user_created_id',
    // },
    {
      Header: intl.formatMessage({ id: "warehouse.import.header.importer" }),
      accessor: "name",
      Cell: (props) => <span className="text-capitalize">{props.value}</span>,
    },
    {
      Header: intl.formatMessage({ id: "warehouse.import.header.phone" }),
      accessor: "phone",
      Cell: (props) => AddCommaPhoneNumber(props.value),
    },
    {
      Header: intl.formatMessage({ id: "warehouse.import.header.address" }),
      accessor: "address",
      Cell: (props) => <span className="text-capitalize">{props.value}</span>,
    },
    {
      Header: intl.formatMessage({ id: "warehouse.import.header.created_at" }),
      accessor: "createdAt",
      Cell: (props) => moment(props.value).format("DD/MM/YYYY"),
    },
  ];
  return (
    <ReactTable
      defaultPageSize={20}
      data={data}
      columns={columns}
      minRows={0}
      showPageJump={false}
      showPageSizeOptions={true}
      PaginationComponent={Pagination}
      NoDataComponent={() => null}
    />
  );
};

export default injectIntl(ContentMultiForm);
